import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaCheck, FaWhatsapp } from 'react-icons/fa';
import styles from './pagina_nutri_marimurra.module.scss';
import Foto from './src/foto3.jpg';
import { WHATSAPP_ONLINE, WHATSAPP_PRESENCIAL, getWhatsappUrl } from './dados_nutri_marimurra.ts';

const SINAIS = [
    'Come menos de 20 alimentos diferentes ou recusa grupos inteiros, como todas as frutas ou legumes.',
    'Está deixando de aceitar alimentos que comia.',
    'Perdeu peso ou não está crescendo como esperado.',
    'Chora, tem ânsia ou vomita diante de um alimento novo.',
    'Engasga com frequência, tem dificuldade para mastigar ou as refeições passam de 40 minutos.',
    'Passou a ter medo de comer depois de um engasgo ou vômito.',
    'Só aceita uma marca ou um único jeito de preparo.',
    'As refeições viraram brigas ou a família prepara um cardápio separado.',
];

const MENSAGEM = 'Olá, Mariana! Vim pelo Instagram e gostaria de agendar uma avaliação de terapia alimentar.';

const Terapia_nutri_marimurra: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pagina_nutri_marimurra}>
            <div className={styles.page}>
                <div className={styles.headerNav}>
                    <Link to="/nutri_marimurra" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                </div>

                <img className={styles.heroImg} src={Foto} alt="Mariana Murra, nutricionista" />

                <p className={styles.eyebrow}>Nutrição infantil</p>
                <h1 className={styles.title}>Terapia alimentar</h1>
                <p className={styles.lead}>
                    Muitas crianças recusam alimentos novos, e na maioria das vezes isso é uma fase. Em alguns
                    casos, porém, a recusa vai além e merece um olhar especializado.
                </p>

                <div className={styles.section}>
                    <span className={styles.sectionNumber}>01</span>
                    <h2 className={styles.sectionTitle}>O que é a terapia alimentar</h2>
                    <p className={styles.paragraph}>
                        É um acompanhamento para crianças com dificuldade em aceitar ou experimentar alimentos.
                        Comer envolve os sentidos, a mastigação, o funcionamento do corpo e as emoções; quando algo
                        disso não vai bem, a criança passa a evitar a comida para se proteger.
                    </p>
                    <p className={styles.paragraph}>
                        Na terapia, a criança conhece o alimento aos poucos e por meio de brincadeiras: olha, toca,
                        cheira, prova e, quando está pronta, come. Ninguém é forçado a comer, e a família participa
                        de todo o processo.
                    </p>
                </div>

                <div className={styles.section}>
                    <span className={styles.sectionNumber}>02</span>
                    <h2 className={styles.sectionTitle}>Seletividade comum ou algo a mais?</h2>
                    <p className={styles.paragraph}>
                        Entre os 2 e os 6 anos é comum a criança desconfiar de alimentos novos. Na seletividade
                        comum, ela aceita alimentos de quase todos os grupos, cresce bem e, de vez em quando, prova
                        algo diferente. Quando a recusa passa a afetar a saúde, o crescimento ou a rotina da família,
                        é hora de procurar ajuda.
                    </p>
                </div>

                <div className={styles.section}>
                    <span className={styles.sectionNumber}>03</span>
                    <h2 className={styles.sectionTitle}>Quando me preocupar</h2>
                    <ul className={styles.checklist}>
                        {SINAIS.map((sinal) => (
                            <li key={sinal}>
                                <FaCheck className={styles.checkIcon} aria-hidden />
                                <span>{sinal}</span>
                            </li>
                        ))}
                    </ul>
                    <p className={styles.highlight}>
                        Crianças com autismo, prematuras ou com histórico de sonda merecem atenção especial. Quanto
                        mais cedo a ajuda chega, mais simples tende a ser o caminho.
                    </p>
                </div>

                <div className={styles.section}>
                    <span className={styles.sectionNumber}>04</span>
                    <h2 className={styles.sectionTitle}>Como funciona</h2>
                    <p className={styles.paragraph}>
                        Começamos com uma avaliação da história alimentar e da relação da criança com a comida. A
                        partir dela, montamos um plano com pequenos passos, trabalhados em sessões lúdicas, e
                        orientamos a família para as refeições em casa.
                    </p>
                    <p className={styles.paragraph}>
                        Quando necessário, atuamos em conjunto com pediatra, fonoaudiólogo, terapeuta ocupacional ou
                        psicólogo.
                    </p>
                </div>

                <div className={styles.cta}>
                    <h2 className={styles.sectionTitle}>Agende uma avaliação</h2>
                    <p className={styles.paragraph}>
                        Se você se identificou com algum desses sinais, entre em contato para agendar uma avaliação.
                    </p>
                    <div className={styles.ctaButtons}>
                        <a
                            href={getWhatsappUrl(WHATSAPP_PRESENCIAL, MENSAGEM)}
                            className={`${styles.button} ${styles.buttonLight}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp aria-hidden />
                            Avaliação presencial
                        </a>
                        <a
                            href={getWhatsappUrl(WHATSAPP_ONLINE, MENSAGEM)}
                            className={`${styles.button} ${styles.buttonOutline}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp aria-hidden />
                            Avaliação online
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Terapia_nutri_marimurra;
